import { DriverInvoiceResumeOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { InvoiceResumeInput } from './types';
import { queryKeys } from '../services/datastore/queryKeys';
import { DEFAULT_CACHE_TIME, queryClient } from '../services/datastore/react-query';
import { QueryOptions } from '../services/datastore/types';
import { driverApi } from '../services/network/Api';

const fetchInvoiceResume = (input: InvoiceResumeInput) =>
  driverApi.get<void, DriverInvoiceResumeOutput>(
    input.date
      ? `/v1/invoice-resume/by-date/${input.date}`
      : input.invoiceResumeKey
      ? `/v1/invoice-resume/${input.invoiceResumeKey}`
      : '/v1/invoice-resume/driver/next-to-pay',
  );

export const useFetchInvoiceResume = (
  input: InvoiceResumeInput = {},
  options: QueryOptions<typeof queryKeys.user.fetchInvoiceResume, DriverInvoiceResumeOutput> = {},
) =>
  useQuery(queryKeys.user.fetchInvoiceResume(input), () => fetchInvoiceResume(input), {
    staleTime: DEFAULT_CACHE_TIME,
    keepPreviousData: true,
    ...options,
  });

export const prefetchInvoiceResume = (input: InvoiceResumeInput) =>
  queryClient.prefetchQuery(queryKeys.user.fetchInvoiceResume(input), () => fetchInvoiceResume(input), {
    staleTime: DEFAULT_CACHE_TIME,
  });
